import { DEFAULT_TARIFF_VALUE } from "config/constants";

export const initialOrderData = {
  ["user_full_name"]: "",
  ["user_phone"]: "",
  ["client_sub_card"]: null,
  ["required_time"]: null,
  reservation: false,
  ["route_address_entrance_from"]: null,
  comment: "",
  ["add_cost"]: 0,
  wagon: false,
  minibus: false,
  premium: false,
  ["flexible_tariff_name"]: "",
  ["route_undefined"]: false,
  ["calc_with_rec_add_cost"]: true,
  ["calculated_tariff_names"]: [DEFAULT_TARIFF_VALUE],
  route: [],
  ["payment_type"]: null,
};
